import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/store-request";
const API_PATH_STORE_REQUEST_STORE =
  ConstantList.API_EN_POINT_STORE + "/store-request";
const API_PATH_STORE = ConstantList.API_EN_POINT_STORE + "/";
const API_PATH_TRANSTYPE_STORE =
  ConstantList.API_EN_POINT_STORE + "/store/trans-type";
const API_PATH_TRANSTYPE_TYPE_STORE =
  ConstantList.API_EN_POINT_STORE + "/store/store-trans-type";
const API_PATH_STORE_TRANSACTION =
  ConstantList.API_EN_POINT_STORE + "/store-transaction";
const API_PATH_STOCK = ConstantList.API_EN_POINT_STORE + "/stock";
const API_PATH_STORE_DEPARTMENT =
  ConstantList.API_EN_POINT_STORE + "/department";

export const getStoreRequestById = (storeRequestId) =>
  axios.get(API_PATH + "/get-by-id/" + storeRequestId);

export const pagingStoreRequest = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const saveOrUpdateStoreRequest = (storeRequest) =>
  axios.post(API_PATH + "/save-or-update", storeRequest);

export const deleteStoreRequest = (storeRequestId) =>
  axios.delete(API_PATH + "/mark-delete/" + storeRequestId);

export const deleteStoreRequestFromStore = (id) =>
  axios.delete(API_PATH_STORE_REQUEST_STORE + "/delete-by-id/" + id);

export const drugEstimateStockOut = (storeRequest) =>
  axios.post(API_PATH + "/get-estimate-drug-stock-out", storeRequest);

export const syntheticStockOutFromEmrDrug = (dto) =>
  axios.post(API_PATH + "/synthetic-stock-out-from-emr-drug", dto);

export const sendMediRequestStore = (dto) =>
  axios.post(API_PATH + "/convert-medi-req-to-store-req", dto);

export const saveStoreRequestOutPatient = (searchObject) =>
  axios.post(API_PATH + "/save-store-request-out-patient", searchObject);

// tong hop don thuoc
export const convertMediReqToStoreReq = (searchObject) =>
  axios.post(API_PATH + "/convert-medi-req-to-list-store-req", searchObject);

// tong hop don thuoc
export const getListStoreRequestByMediRequest = (id) =>
  axios.get(API_PATH + "/get-list-store-req-by-medi-req/" + id);

// luu phieu xuat kho
export const saveListStoreReq = (searchObject) =>
  axios.post(API_PATH + "/save-list-store-req", searchObject);

// save list storeRequest by medicationRequest (convert + save) - truyen len mediReq trong dto
export const saveListStoreReqByMediReq = (dto) =>
  axios.post(API_PATH + "/save-list-store-req-by-medi-req", dto);

// gui yc xuat kho
export const sendStoreRequestByVisit = (searchObject) =>
  axios.post(API_PATH + "/send-store-request-by-visit", searchObject);

// lay ton kho
export const getListDrugInventoryFromStore = (searchObject) =>
  axios.post(API_PATH + "/get-list-drug-inventory-from-store", searchObject);

export const getListStoreRequestItemByEncId = (storeRequestItemId) =>
  axios.get(
    API_PATH + "/get-list-store-req-item-by-enc-id/" + storeRequestItemId
  );

export const saveRequestInpatientRefund = (searchObject) =>
  axios.post(API_PATH + "/save-request-inpatient-refund", searchObject);

export const pagingStore = (searchObject) =>
  axios.post(API_PATH_STORE + "store/searchByDto", searchObject);
export const pagingStoreRequestByStore = (searchObject) =>
  axios.post(API_PATH_STORE + "store-request/search-by-page", searchObject);

export const getStoreRequestByIdFromStore = (storeRequestId) =>
  axios.get(API_PATH_STORE + "store-request/get-by-id/" + storeRequestId);

export const pagingTransType = (searchPayload) =>
  axios.post(`${API_PATH_TRANSTYPE_STORE}/search-by-dto`, searchPayload);

export const pagingStoreByStoreTransType = (searchObject) => {
  var url = API_PATH_TRANSTYPE_TYPE_STORE + "/search-store-by-dto";
  return axios.post(url, searchObject);
};

export const pagingStockOutsFromStore = (searchObject) => {
  var url = API_PATH_STORE + "store-transaction/searchByDto";
  return axios.post(url, searchObject);
};

export const getStockOutFromStore = (id) =>
  axios.get(API_PATH_STORE + "store-transaction/" + id);

export const createStoreRequestFromStore = (dto) =>
  axios.post(API_PATH_STORE + "store-request/create-store-request", dto);

export const updateStoreRequestFromStore = (dto, id) =>
  axios.put(API_PATH_STORE + "store-request/update-store-request/" + id, dto);

export const checkDuplicateCodeFromStore = (code) =>
  axios.get(API_PATH_STORE + "store-request/check-duplicate-code/" + code);

export const getFullListDtoByStoreRequestId = (storeRequestId) => {
  return axios.get(
    API_PATH_STORE_TRANSACTION +
      "/get-full-list-dto-by-store-request-id/" +
      storeRequestId
  );
};

export const getFullListDtoSyntheticByStoreRequestId = (id) => {
  var url =
    API_PATH_STORE_REQUEST_STORE + "/get-list-transaction-print-form/" + id;
  return axios.get(url);
};

export const updateTransactionStatus = (obj) => {
  let url = API_PATH_STORE_TRANSACTION + "/update-transaction-status";
  return axios.put(url, obj);
};

export const pagingDepartment = (obj) => {
  let { pageIndex, pageSize } = obj;
  const url = API_PATH_STORE_DEPARTMENT + `/${pageIndex}/${pageSize}`;
  return axios.get(url, obj);
};

export const viewCompensationCabinetAsCustomer = (obj) => {
  var url =
    API_PATH_STORE_REQUEST_STORE + "/view-compensation-cabinet-as-customer";
  return axios.post(url, obj);
};

export const exportSyntheticCompensationCabinet = (obj) => {
  var url =
    API_PATH_STORE_REQUEST_STORE + "/export-synthetic-compensation-cabinet";
  return axios.post(url, obj);
};

export const saveSyntheticCompensationCabinet = (obj) => {
  var url =
    API_PATH_STORE_REQUEST_STORE + "/save-all-synthetic-compensation-cabinet";
  return axios.post(url, obj);
};
export const viewCompensationCabinetAsCustomerByRequestId = (requestId) => {
  var url =
    API_PATH_STORE_REQUEST_STORE +
    "/view-compensation-cabinet-as-customer/" +
    requestId;
  return axios.get(url);
};

export const getListStoreTransactionByCombineRequest = (id) => {
  var url =
    API_PATH_STORE_REQUEST_STORE +
    "/get-list-store-transaction-by-combine-request/" +
    id;
  return axios.get(url);
};

export const getListGroupReqItem = (searchObject) =>
  axios.post(
    API_PATH_STORE_REQUEST_STORE + "/get-list-group-req-item",
    searchObject
  );

export const exportSyntheticReceiptRequest = (dto) => {
  return axios.post(
    API_PATH_STORE_REQUEST_STORE + "/export-synthetic-receipt-request",
    dto
  );
};

// yc xuat ban sp tu kho la
export const requestStoreExportProducts = (obj) =>
  axios.post(API_PATH + "/request-store-export-products", obj);

export const exportProductsFromHis = (obj) =>
  axios.post(API_PATH + "/export-products-from-his", obj);

export const getListStoreRequestItem = (obj) =>
  axios.post(API_PATH + "/get-list-store-request-item", obj);

// Hoàn trả ngoại trú
export const getReturnExportTransactionsByDrugOrder = (drugOrderId) =>
  axios.get(API_PATH + "/get-return-export-transactions-by-drug-order/" + drugOrderId);

export const getReturnSummaryByDrugOrderAndExportTx = (drugOrderId, exportTransactionId) =>
  axios.get(
    API_PATH +
      "/get-return-summary-by-drug-order/" +
      drugOrderId +
      "/export-transaction/" +
      exportTransactionId
  );

export const saveRequestOutpatientRefund = (obj) =>
  axios.post(API_PATH + "/save-request-outpatient-refund", obj);

export const checkInventory = (searchObject) =>
  axios.post(API_PATH_STORE_TRANSACTION + "/check-inventory", searchObject);

/** POST /api/stock/availability — một sản phẩm + một kho (productCode, storeCode). */
export const fetchStockAvailability = (request) =>
  axios.post(API_PATH_STOCK + "/availability", request);

/**
 * POST /api/stock/product-skus — lấy đơn vị (SKU) + đơn vị nhỏ nhất theo danh sách mã SP.
 * KHÔNG phụ thuộc kho → quy đổi đơn vị tính ↔ đơn vị nhỏ nhất được ngay khi chưa chọn kho.
 * Trả về [{ productCode, productId, minSkuCode, minSkuName, skus: [{ skuCode, coefficient, ... }] }]
 */
export const fetchProductSkus = async (productCodes = []) => {
  const uniqueCodes = [...new Set((productCodes || []).filter(Boolean))];
  if (uniqueCodes.length === 0) return [];
  try {
    const { data } = await axios.post(
      API_PATH_STOCK + "/product-skus",
      uniqueCodes
    );
    return data || [];
  } catch (e) {
    return [];
  }
};

/**
 * Lấy tồn khả dụng cho nhiều mã SP trong cùng một kho — CHỈ cần tổng theo đơn vị nhỏ nhất.
 * Không cần groupBy: hệ số quy đổi lấy riêng từ /api/stock/product-skus.
 */
export const fetchStockAvailabilityForProducts = async (
  storeCode,
  productCodes = []
) => {
  const uniqueCodes = [...new Set(productCodes.filter(Boolean))];
  if (!storeCode || uniqueCodes.length === 0) {
    return [];
  }

  const results = await Promise.all(
    uniqueCodes.map((productCode) =>
      fetchStockAvailability({
        productCode,
        storeCode,
      })
        .then(({ data }) =>
          data ? { ...data, productCode: data.productCode || productCode } : null
        )
        .catch(() => null)
    )
  );

  return results.filter(Boolean).map((data) => ({
    productCode: data.productCode,
    productId: data.productId,
    productName: data.productName,
    minSkuId: data.minSkuId,
    minSkuCode: data.minSkuCode,
    minSkuName: data.minSkuName,
    totalMinSku: data.totalMinSku,
    reservedMinSku: data.reservedMinSku,
    inventoryQuantity:
      (data.totalMinSku || 0) - (data.reservedMinSku || 0),
  }));
};

export const stockOutFromHis = (obj) =>
  axios.post(API_PATH + "/stock-out-from-his", obj);

export const stockOutListFromHis = (obj) =>
  axios.post(API_PATH + "/stock-out-list-from-his", obj);
